export const FETCH_EVENT_NEWS_PAGE = "FETCH_EVENT_NEWS_PAGE";
export const FETCH_EVENT_NEWS_PAGE_SUCCESS = "FETCH_EVENT_NEWS_PAGE_SUCCESS";
export const FETCH_EVENT_NEWS_PAGE_ERROR = "FETCH_EVENT_NEWS_PAGE_ERROR";

export const FETCH_NEWS_DETAIL_PAGE = "FETCH_NEWS_DETAIL_PAGE";
export const FETCH_NEWS_DETAIL_PAGE_SUCCESS = "FETCH_NEWS_DETAIL_PAGE_SUCCESS";
export const FETCH_NEWS_DETAIL_PAGE_ERROR = "FETCH_NEWS_DETAIL_PAGE_ERROR";

export const FETCH_DISTRICT_LIST = "FETCH_DISTRICT_LIST";
export const FETCH_DISTRICT_LIST_SUCCESS = "FETCH_DISTRICT_LIST_SUCCESS";
export const FETCH_DISTRICT_LIST_ERROR = "FETCH_DISTRICT_LIST_ERROR";

export const FETCH_DASHBOARD_DATA = "FETCH_DASHBOARD_DATA";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_ERROR = "FETCH_DASHBOARD_DATA_ERROR";

export const FETCH_EVENTS = "FETCH_EVENTS";
export const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_ERROR = "FETCH_EVENTS_ERROR";

export const FETCH_TEAM_LIST_BY_CATEGORY = "FETCH_TEAM_LIST_BY_CATEGORY";
export const FETCH_TEAM_LIST_BY_CATEGORY_SUCCESS = "FETCH_TEAM_LIST_BY_CATEGORY_SUCCESS";
export const FETCH_TEAM_LIST_BY_CATEGORY_ERROR = "FETCH_TEAM_LIST_BY_CATEGORY_ERROR";

export const FETCH_TEAM_CATEGORY_LIST = "FETCH_TEAM_CATEGORY_LIST";
export const FETCH_TEAM_CATEGORY_LIST_SUCCESS = "FETCH_TEAM_CATEGORY_LIST_SUCCESS";
export const FETCH_TEAM_CATEGORY_LIST_ERROR = "FETCH_TEAM_CATEGORY_LIST_ERROR";

export const FETCH_RELATED_NEWS_LIST = "FETCH_RELATED_NEWS_LIST";
export const FETCH_RELATED_NEWS_LIST_SUCCESS = "FETCH_RELATED_NEWS_LIST_SUCCESS";
export const FETCH_RELATED_NEWS_LIST_ERROR = "FETCH_RELATED_NEWS_LIST_ERROR";

export const FETCH_FAQ_CATEGORY = "FETCH_FAQ_CATEGORY";
export const FETCH_FAQ_CATEGORY_SUCCESS = "FETCH_FAQ_CATEGORY_SUCCESS";
export const FETCH_FAQ_CATEGORY_ERROR = "FETCH_FAQ_CATEGORY_ERROR";

export const FETCH_FAQ = "FETCH_FAQ";
export const FETCH_FAQ_SUCCESS = "FETCH_FAQ_SUCCESS";
export const FETCH_FAQ_ERROR = "FETCH_FAQ_ERROR";

export const FETCH_HOMEPAGE_LATEST_NEWS = "FETCH_HOMEPAGE_LATEST_NEWS";
export const FETCH_HOMEPAGE_LATEST_NEWS_SUCCESS = "FETCH_HOMEPAGE_LATEST_NEWS_SUCCESS";
export const FETCH_HOMEPAGE_LATEST_NEWS_ERROR = "FETCH_HOMEPAGE_LATEST_NEWS_ERROR";

export const HOMEPAGE_MAP_INFOGRAPHY = "HOMEPAGE_MAP_INFOGRAPHY";
export const HOMEPAGE_MAP_INFOGRAPHY_SUCCESS = "HOMEPAGE_MAP_INFOGRAPHY_SUCCESS";
export const HOMEPAGE_MAP_INFOGRAPHY_ERROR = "HOMEPAGE_MAP_INFOGRAPHY_ERROR";

export const FETCH_SLIDER = "FETCH_SLIDER";
export const FETCH_SLIDER_SUCCESS = "FETCH_SLIDER_SUCCESS";
export const FETCH_SLIDER_ERROR = "FETCH_SLIDER_ERROR";

export const FETCH_MARQUEE_NEWS = "FETCH_MARQUEE_NEWS";
export const FETCH_MARQUEE_NEWS_SUCCESS = "FETCH_MARQUEE_NEWS_SUCCESS";
export const FETCH_MARQUEE_NEWS_ERROR = "FETCH_MARQUEE_NEWS_ERROR";

export const FETCH_FLICKR_IMAGES = "FETCH_FLICKR_IMAGES";
export const FETCH_FLICKR_IMAGES_SUCCESS = "FETCH_FLICKR_IMAGES_SUCCESS";
export const FETCH_FLICKR_IMAGES_ERROR = "FETCH_FLICKR_IMAGES_ERROR";

export const FETCH_FLICKR_DETAIL_IMAGES = "FETCH_FLICKR_DETAIL_IMAGES";
export const FETCH_FLICKR_DETAIL_IMAGES_SUCCESS = "FETCH_FLICKR_DETAIL_IMAGES_SUCCESS";
export const FETCH_FLICKR_DETAIL_IMAGES_ERROR = "FETCH_FLICKR_DETAIL_IMAGES_ERROR";

export const FETCH_HOMEPAGE_PARTNER_STORIES = "FETCH_HOMEPAGE_PARTNER_STORIES";
export const FETCH_HOMEPAGE_PARTNER_STORIES_SUCCESS = "FETCH_HOMEPAGE_PARTNER_STORIES_SUCCESS";
export const FETCH_HOMEPAGE_PARTNER_STORIES_ERROR = "FETCH_HOMEPAGE_PARTNER_STORIES_ERROR";

export const FETCH_PARTNER_STORIES = "FETCH_PARTNER_STORIES_LIST";
export const FETCH_PARTNER_STORIES_SUCCESS = "FETCH_PARTNER_STORIES_LIST_SUCCESS";
export const FETCH_PARTNER_STORIES_ERROR = "FETCH_PARTNER_STORIES_LIST_ERROR";

export const FETCH_PARTNERS_LIST = "FETCH_PARTNERS_LIST";
export const FETCH_PARTNERS_LIST_SUCCESS = "FETCH_PARTNERS_LIST_SUCCESS";
export const FETCH_PARTNERS_LIST_ERROR = "FETCH_PARTNERS_LIST_ERROR";

export const FETCH_IMPLEMENTING_PARTNERS_LIST = "FETCH_IMPLEMENTING_PARTNERS_LIST";
export const FETCH_IMPLEMENTING_PARTNERS_LIST_SUCCESS = "FETCH_IMPLEMENTING_PARTNERS_LIST_SUCCESS";
export const FETCH_IMPLEMENTING_PARTNERS_LIST_ERROR = "FETCH_IMPLEMENTING_PARTNERS_LIST_ERROR";

export const FETCH_HOMEPAGE_HRRP_REFERENCE = "FETCH_HOMEPAGE_HRRP_REFERENCE";
export const FETCH_HOMEPAGE_HRRP_REFERENCE_SUCCESS = "FETCH_HOMEPAGE_HRRP_REFERENCE_SUCCESS";
export const FETCH_HOMEPAGE_HRRP_REFERENCE_ERROR = "FETCH_HOMEPAGE_HRRP_REFERENCE_ERROR";

export const FETCH_HOMEPAGE_RECENT_MINUTES = "FETCH_HOMEPAGE_RECENT_MINUTES";
export const FETCH_HOMEPAGE_RECENT_MINUTES_SUCCESS = "FETCH_HOMEPAGE_RECENT_MINUTES_SUCCESS";
export const FETCH_HOMEPAGE_RECENT_MINUTES_ERROR = "FETCH_HOMEPAGE_RECENT_MINUTES_ERROR";

//++++++++RESOURCE AND MATERIAL++++++++++++++  

export const FETCH_RESOURCE_MATERIAL_CATEGORY = "FETCH_RESOURCE_MATERIAL_CATEGORY";
export const FETCH_RESOURCE_MATERIAL_CATEGORY_SUCCESS = "FETCH_RESOURCE_MATERIAL_CATEGORY_SUCCESS";
export const FETCH_RESOURCE_MATERIAL_CATEGORY_ERROR = "FETCH_RESOURCE_MATERIAL_CATEGORY_ERROR";

// +++++++++++++++++++++++++++++++++++++

export const FETCH_MAP_LIST = "FETCH_MAP_LIST";
export const FETCH_MAP_LIST_SUCCESS = "FETCH_MAP_LIST_SUCCESS";
export const FETCH_MAP_LIST_ERROR = "FETCH_MAP_LIST_ERROR";


export const FETCH_DISTRICT_MAP_LIST = "FETCH_DISTRICT_MAP_LIST";
export const FETCH_DISTRICT_MAP_LIST_SUCCESS = "FETCH_DISTRICT_MAP_LIST_SUCCESS";
export const FETCH_DISTRICT_MAP_LIST_ERROR = "FETCH_DISTRICT_MAP_LIST_ERROR";


export const FETCH_MAP_CATEGORY_LIST = "FETCH_MAP_CATEGORY_LIST";
export const FETCH_MAP_CATEGORY_LIST_SUCCESS = "FETCH_MAP_CATEGORY_LIST_SUCCESS";
export const FETCH_MAP_CATEGORY_LIST_ERROR = "FETCH_MAP_CATEGORY_LIST_ERROR";

export const FETCH_MEETING_LIST = "FETCH_MEETING_LIST";
export const FETCH_MEETING_LIST_SUCCESS = "FETCH_MEETING_LIST_SUCCESS";
export const FETCH_MEETING_LIST_ERROR = "FETCH_MEETING_LIST_ERROR";

export const FETCH_MEETING_DETAILS = "FETCH_MEETING_DETAILS";
export const FETCH_MEETING_DETAILS_SUCCESS = "FETCH_MEETING_DETAILS_SUCCESS";
export const FETCH_MEETING_DETAILS_ERROR = "FETCH_MEETING_DETAILS_ERROR";

export const FETCH_MEETING_CATEGORY_LIST = "FETCH_MEETING_CATEGORY_LIST";
export const FETCH_MEETING_CATEGORY_LIST_SUCCESS = "FETCH_MEETING_CATEGORY_LIST_SUCCESS";
export const FETCH_MEETING_CATEGORY_LIST_ERROR = "FETCH_MEETING_CATEGORY_LIST_ERROR";

export const FETCH_INFOGRAPHICS_LIST = "FETCH_INFOGRAPHICS_LIST";
export const FETCH_INFOGRAPHICS_LIST_SUCCESS = "FETCH_INFOGRAPHICS_LIST_SUCCESS";
export const FETCH_INFOGRAPHICS_LIST_ERROR = "FETCH_INFOGRAPHICS_LIST_ERROR";

export const FETCH_DISTRIST_INFOGRAPHICS_LIST = "FETCH_DISTRIST_INFOGRAPHICS_LIST";
export const FETCH_DISTRIST_INFOGRAPHICS_LIST_SUCCESS = "FETCH_DISTRIST_INFOGRAPHICS_LIST_SUCCESS";
export const FETCH_DISTRIST_INFOGRAPHICS_LIST_ERROR = "FETCH_DISTRIST_INFOGRAPHICS_LIST_ERROR";

export const FETCH_INFOGRAPHICS_CATEGORY_LIST = "FETCH_INFOGRAPHICS_CATEGORY_LIST";
export const FETCH_INFOGRAPHICS_CATEGORY_LIST_SUCCESS = "FETCH_INFOGRAPHICS_CATEGORY_LIST_SUCCESS";
export const FETCH_INFOGRAPHICS_CATEGORY_LIST_ERROR = "FETCH_INFOGRAPHICS_CATEGORY_LIST_ERROR";

export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS = "FETCH_SETTINGS_SUCCESS";
export const FETCH_SETTINGS_ERROR = "FETCH_SETTINGS_ERROR";

export const STORE_CSV_DATA = "STORE_CSV_DATA";
export const STORE_MAP_DATA = "STORE_MAP_DATA";

export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SHOW_PRELOADER = "SHOW_PRELOADER";